var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"editorWrapper",attrs:{"tile":"","outlined":""}},[_c('div',{ref:"editor",staticClass:"monaco-editor"})])}
var staticRenderFns = []

export { render, staticRenderFns }